import { decode } from 'js-base64'

export const resolveBase64Namespace = (value: string): string => {
    const decodedValue = decode(value)
    const isSvg = decodedValue.startsWith('<svg') || decodedValue.startsWith('<?xml')
    const namespace = isSvg ? 'data:image/svg+xml' : 'data:image/png'
    return namespace
}
